angular.module('resourceCenterSharedModule').factory('shareDocApiService', [
    'trsHttpService',
    '$q',
    '$state',
    'modalDialog',
    'trsspliceString',
    'deleteSharedManuscriptService',
    'resourceCenterService',
    function(trsHttpService, $q, $state, modalDialog, trsspliceString, deleteSharedManuscriptService, resourceCenterService) {
        let commonParams = {
            serviceid: 'mlf_releaseSource',
            dataSource: 'wcm',
        };

        /**
         * [queryShareCatsByDoc description 查询所有分类中相同稿件]
         *
         * @param  {[type]}  ids   [ids description]
         * @param  {[type]}  array   [array description]
         * @param  {[type]}  $scope   [array description]
         *
         * @return  {[type]}   [return description]
         */
        function queryShareCatsByDoc(ids, array, $scope) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_releaseSource',
                methodname: 'queryShareCatsByDoc',
                MetaDataId: ids,
                ShareCategoryId: array[0].CATEGORYID || $state.params.nodeid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                if (data instanceof Array === true) {
                    defer.resolve(data);
                } else if (data.DATA instanceof Array === true) {
                    defer.resolve(data.DATA);
                } else {
                    defer.reject();
                }
            });
            return defer.promise;
        }

        return {

            /**
             * [commonDeleteDrafts description]普通删除稿件
             *
             * @param  {[type]}  $scope   [$scope description]
             *
             * @return  {[type]}   [return description]
             */
            commonDeleteDrafts: function ($scope) {
                var defer = $q.defer();
                var array = $scope.data.selectedArray ? $scope.data.selectedArray : [$scope.detailInfos];
                if (!array.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                } else if (array.length > 1) {
                    modalDialog.alertType('只能选择单条稿件进行取消共享', '', 'warning', 'confirm');
                    return;
                }
                var ids = trsspliceString.spliceString(array, 'METADATAID', ',');
                queryShareCatsByDoc(ids, array, $scope).then(function (data) {
                    if (data.length > 0) {
                        deleteSharedManuscriptService.deleteManuscript(data).then(function (result) {
                            var array;
                            if (result === '') {
                                array = array[0].CATEGORYID;
                            } else {
                                array = result.split(',');
                                array.push(array[0].CATEGORYID);
                                array = array.join(',');
                            }
                            $scope.loadingPromise = resourceCenterService.commonDeleteRelease(ids, array).then(
                                function (data) {
                                    if (data && data.ISSUCCESS === 'true') {
                                        modalDialog.alertType('取消共享成功！', '', 'success', false, '');
                                        defer.resolve();
                                    }
                                },
                                function () {
                                    defer.reject();
                                }
                            );
                        });
                    } else {
                        modalDialog.confirmModal('取消共享', '是否从共享稿库中取消共享', function () {
                            $scope.loadingPromise = resourceCenterService.commonDeleteRelease(ids, array[0].CATEGORYID).then(
                                function (data) {
                                    if (data && data.ISSUCCESS === 'true') {
                                        modalDialog.alertType('取消共享成功！', '', 'success', false, '');
                                        defer.resolve();
                                    }
                                },
                                function () {
                                    defer.reject();
                                }
                            );
                        });
                    }
                });
                return defer.promise;
            },
        
            /**
             * [adminDeleteDrafts description]管理员删除稿件// 20200608更改为管理员撤稿
             *
             * @param  {[type]}  $scope   [$scope description]
             *
             * @return  {[type]}
             *   [return description]
             */
            adminDeleteDrafts: function ($scope) {
                var defer = $q.defer();
                var array = $scope.data.selectedArray ? $scope.data.selectedArray : [$scope.detailInfos];
                if (!array.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                } else if (array.length > 1) {
                    modalDialog.alertType('只能选择单条稿件进行管理员撤稿', '', 'warning', 'confirm');
                    return;
                }
                var ids = trsspliceString.spliceString(array, 'METADATAID', ',');
                queryShareCatsByDoc(ids, array, $scope).then(function (data) {
                    if (data.length > 0) {
                        deleteSharedManuscriptService.deleteManuscript(data).then(function (result) {
                            var array;
                            if (result === '') {
                                array = array[0].CATEGORYID;
                            } else {
                                array = result.split(',');
                                array.push(array[0].CATEGORYID);
                                array = array.join(',');
                            }
                            $scope.loadingPromise = resourceCenterService.adminDeleteRelease(ids, array).then(
                                function (data) {
                                    if (data && data.ISSUCCESS === 'true') {
                                        modalDialog.alertType('管理员撤稿成功！', '', 'success', false, '');
                                        defer.resolve();
                                    }
                                },
                                function () {
                                    defer.reject();
                                }
                            );
                        });
                    } else {
                        modalDialog.confirmModal('管理员撤稿', '是否从共享稿库管理员撤稿', function () {
                            $scope.loadingPromise = resourceCenterService.adminDeleteRelease(ids, array[0].CATEGORYID).then(
                                function (data) {
                                    if (data && data.ISSUCCESS === 'true') {
                                        modalDialog.alertType('管理员撤稿成功！', '', 'success', false, '');
                                        defer.resolve();
                                    }
                                },
                                function () {
                                    defer.reject();
                                }
                            );
                        });
                    }
                });
                return defer.promise;
            }
        };

        /**
             * [dealParams 公共的参数适配方法]
             *
             * @param   {[type]}  params  [params description]
             *
             * @return  {[type]}          [return description]
             */
        function dealParams(params) {
            return params;
        }

        /**
             * [dealData 适配响应数据]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
        function dealData(data) {
            return data;
        }

        /**
             * [requestData 统一的请求方法，默认请求方法]
             *
             * @param   {[type]}  params  [params description]
             *
             * @return  {[type]}          [return description]
             */
        function requestData(params) {
            let deffer = $q.defer();
            let requestParams = angular.extend({}, commonParams, dealParams(params));
            let dataSource = requestParams.dataSource ? requestParams.dataSource : 'bigData';
            let httpMethod = requestParams.httpMethod ? requestParams.httpMethod : 'post';
            if (requestParams.dataSource) {
                delete requestParams.dataSource;
            }
            if (requestParams.httpMethod) {
                delete requestParams.httpMethod;
            }
            let url = getRequestUrl(dataSource);
            trsHttpService.httpServer(url, requestParams, httpMethod).then(
                function(data) {
                    let result = dealData(data);
                    deffer.resolve(result);
                },
                function(data) {
                    deffer.reject(data);
                }
            );
            return deffer.promise;
        }

        /**
             * [getRequestUrl 获取请求URL]
             *
             * @param   {[type]}  type  [type description]
             *
             * @return  {[type]}        [return description]
             */
        function getRequestUrl(type){
            let urlMap = {
                'wcm': trsHttpService.getWCMRootUrl(), 
                'bigData': trsHttpService.getBigDataRootUrl(), 
                'wb': trsHttpService.getWeiboRootUrl(),
            };
            return urlMap[type];
        }
    },
]).value('shareDocApiParams', {
    // 共享稿库二级分类下分日期稿件数量查询参数
    dateCountParams: {
        methodname: 'queryShareDocsDataCount',
        CurrPage: 1,
        PageSize: 10,
        MetaCategoryId: '',
        DocType: '', // 稿件类型
        ShareTimeStart: '', // 开始日期
        ShareTimeEnd: '', // 结束
        OriginalType: '', // 原创稿类型
        IsUnit: false, // 本媒体稿件
        fromTenantId: '' // 供稿单位id
    },
    // 通讯员稿库分日期稿件数量查询参数
    ugcArticlCountParams: {
        serviceid: 'mlf_ugc',
        methodname: 'queryArticleCount',
        Method: 'queryArticleCount',
        MetaCategoryId: '',
        start: '',
        FirstClassId: '',
        end: '',
    },
    // 县融供稿下供稿单位列表查询参数
    countyFeedSharedTenantNameParams: {
        methodName: 'queryHaveSharedTenantName'
    },
    // 共享稿库一级分类分日期稿件数量查询参数
    shareDocsDateCountOfFirstParams: {
        methodname: 'queryShareDocsDataCountOfFirst',
        MetaCategoryId: '',
        IsUnit: '',
        CurrPage: '',
        PageSize: '',
        DocType: '',
        OriginalType: '',
        ShareTimeStart: '',
        ShareTimeEnd: ''
    },
    // 资源中心共享稿库的操作权限查询参数
    btnRightsOfShareDocParams: {
        serviceid: 'mlf_metadataright',
        methodname: 'queryOperKeysOfNormalModal',
        ModalName: '资源中心',
        Classify: 'source.sharedoc',
    },
    // 通讯员稿库文章列表查询参数
    ugcArticlListParams: {
        serviceid: 'mlf_ugc',
        methodname: 'queryArticles',
        Method: 'queryArticles',
        MetaCategoryId: '',
        ContainPage: '0',
        start: '',
        end: '',
        FirstClassId: '',
    },
    // 共享稿库一级分类数据查询参数
    firstCateListForCloudParams: {
        methodname: 'queryShareDocsForCloudOfFirst',
        MetaCategoryId: '',
        IsUnit: '',
        CurrPage: '',
        PageSize: '',
        DocType: '',
        OriginalType: '',
        ShareTimeStart: '',
        ShareTimeEnd: ''
    },
    // 集团已发数查询参数
    groupIssuedCountsParams: {
        methodname: 'queryGroupIssuedCounts',
        MetaDataIds: '',
    }
});
